import { useTranslation } from "react-i18next";

import { DropdownActionListProps, DropdownActionsList } from "components";
import { Earth } from "icons";

const languages = [
  {
    key: "en",
    value: "English",
  },
  {
    key: "he",
    value: "עברית",
  },
];

export interface LanguageDropdownProps extends Partial<DropdownActionListProps> {}

export const LanguageDropdown = ({ ...props }: LanguageDropdownProps) => {
  const { t, i18n } = useTranslation("translation");

  return (
    <DropdownActionsList title={t("language_name")} logo={<Earth />} {...props}>
      {languages.map(({ value, key }) => (
        <DropdownActionsList.Item
          selected={i18n.resolvedLanguage === key}
          onClick={() => i18n.changeLanguage(key)}
          key={key}
        >
          {value}
        </DropdownActionsList.Item>
      ))}
    </DropdownActionsList>
  );
};
